<template>
  <transition name="drawer-slide-left" @after-leave="handleAfterLeave">
    <div class="drawer" v-show="currentValue" :class="{fullscreen: fullscreen}">
      <slot/>
    </div>
  </transition>
</template>

<script>
import PopupMixins from '@/utils/mixins/popup'
export default {
  name: 'jc-drawer',
  mixins: [PopupMixins],
  props: {
    value: Boolean,
    fullscreen: Boolean
  },
  data () {
    return {
      currentValue: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.currentValue = this.value
      }
    },
    currentValue () {
      if (this.currentValue) {
        this.rendered = true
        this.open()
      }
      this.$emit('input', this.currentValue)
    }
  },
  methods: {
    handleAfterLeave () {
      this.handleLockScroll(true)
      this.$emit('closed')
    },
    handleCloseBtnClick () {
      this.currentValue = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/popup/drawer.vue